<template>
  <div class="bind-success">
    <order-card payerDisabled orderDisabled/>
    <router-link to="/bind_ticket" replace class="btn-common">切换船票</router-link>
  </div>
</template>

<script>
import OrderCard from './order_detail/OrderCard'
export default {
  name: 'PageBindSuccess',

  components: {
    OrderCard
  }
}
</script>

<style lang="less" scoped>
.bind-success {
  padding: 30px 50px;
}
.btn-common {
  margin-top: 40px;
}
</style>
